import React, { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";
import axios from "axios";
import FormData from "form-data";

// Field map for Aadhaar (documenttype = 1)
const FIELD_MAP = {
  0: [
    ["documentType", "Document Type"],
    ['requestId', 'Request ID']
  ],
  1: [
    ["documenttype", "Document Type"],
    ["documentname", "Document Name"],
    ["item.details.aadhaar.qrstatus", "QR Status"],
    ["item.details.aadhaar.value", "Aadhaar Number"],
    ["item.details.aadhaar.ismasked", "Masked"],
    ["item.details.aadhaar.masked_value", "Masked Image"],
    ["item.details.name.value", "Name"],
    ["item.details.gender.value", "Gender"],
    ["item.details.dob", "Date of Birth"],
    ["item.details.husband.value", "Husband's Name"],
    ["item.details.father.value", "Father's Name"],
    ["item.details.daughter_of.value", "Daughter Of"],
    ["item.details.address.care_of", "Care Of"],
    ["item.details.address.house_number", "House Number"],
    ["item.details.address.landmark", "Landmark"],
    ["item.details.address.line1", "Address Line 1"],
    ["item.details.address.line2", "Address Line 2"],
    ["item.details.address.city", "City"],
    ["item.details.address.district", "District"],
    ["item.details.address.state", "State"],
    ["item.details.address.pin", "PIN Code"],
    ["item.details.aadhaar.color", "Color"],
    ["item.details.face.faceString", "Face Image"],
    ["item.details.format_match", "Format Match"],
    ['requestId', 'Request ID']
  ],
  2: [
    ["documenttype", "Document Type"],
    ["documentname", "Document Name"],
    ["status", "Status"],
    ["docnumber", "Passport Number"],
    ["country", "Country"],
    ["surname", "Surname"],
    ["name", "Name"],
    ["nationality", "Nationality"],
    ["dob", "Date of Birth"],
    ["gender", "Gender"],
    ["expirydate", "Expiry Date"],
    ["fathername", "Father's Name"],
    ["mothername", "Mother's Name"],
    ["address", "Address"],
    ["formatflag", "Format"],
    ["isexpired", "Is Expired"],
    ['requestId', 'Request ID']
  ],
  3: [
    ["documenttype", "Document Type"],
    ["documentname", "Document Name"],
    ["status", "Status"],
    ["drivinglicenseno", "License Number"],
    ["name", "Name"],
    ["swd", "S/W/D"],
    ["dateofissue", "Date of Issue"],
    ["currentdateofissue", "Current Date of Issue"],
    ["validitynt", "Validity (Non-Transport)"],
    ["validityt", "Validity (Transport)"],
    ["dob", "Date of Birth"],
    ["classofvehicle", "Class of Vehicle"],
    ["address", "Address"],
    ["districtname", "District"],
    ["statename", "State"],
    ["pincode", "PIN Code"],
    ["isexpired", "Is Expired"],
    ['requestId', 'Request ID']
  ],
  4: [
    ["documenttype", "Document Type"],
    ["documentname", "Document Name"],
    ["status", "Status"],
    ["voterid", "Voter ID"],
    ["name", "Name"],
    ["guardianname", "Guardian Name"],
    ["gender", "Gender"],
    ["dob", "Date of Birth"],
    ["yearofbirth", "Year of Birth"],
    ["age", "Age"],
    ["address", "Address"],
    ["district", "District"],
    ["state", "State"],
    ["pincode", "PIN Code"],
    ["formatflag", "Format"],
    ['requestId', 'Request ID']
  ],
  5: [
    ["documenttype", "Document Type"],
    ["documentname", "Document Name"],
    ["status", "Status"],
    ["panno", "PAN Number"],
    ["name", "Name"],
    ["fathername", "Father's Name"],
    ["dateofbirth", "Date of Birth"],
    ["iscolor", "Is Color"],
    ["remark", "Remark"],
    ["qravailable", "QR Available"],
    ["facestring", "Face String"],
    ['requestId', 'Request ID']
  ],
};

// ✅ Helper to handle both flat and nested key access
const getNestedValue = (obj, path, defaultValue = "-") => {
  if (Object.prototype.hasOwnProperty.call(obj, path)) return obj[path];
  const value = path.split(".").reduce((acc, key) => {
    return acc && acc[key] !== undefined ? acc[key] : undefined;
  }, obj);
  return value !== undefined ? value : defaultValue;
};

function PiData() {
  const [img, setImg] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result
        .replace("data:", "")
        .replace(/^.+,/, "");
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = () => {
    if (!img) return alert("Please upload an image first.");
    setLoading(true);
    setData(null);

    const form = new FormData();
    form.append("ImageByte", img);

    axios({
      method: "post",
      url: "https://itiy75or47.execute-api.ap-south-1.amazonaws.com/default/pidata",
      headers: {
        "x-api-key": "MWqM1xE9306vxLa4Nicii6fFfmoRn01M75jj1z3p",
        authorizationToken: "43ttM0fR6IJ8JWMA",
      },
      data: form,
    })
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        alert("Something went wrong with the server");
        console.error(err);
      });
  };

  const renderData = () => {
    const docType = data?.documentType || data?.documenttype;
    if (!data || !docType) return null;

    const fields = FIELD_MAP[docType] || [["documenttype", "Unknown Type"]];

    return (
      <table className="table">
        <tbody>
          {fields.map(([key, label]) => {
            const value = getNestedValue(data, key);
            const isBase64Image =
              typeof value === "string" && value.startsWith("/9j");

            return (
              <tr key={key}>
                <th width="30%">{label}</th>
                <td>
                  {isBase64Image ? (
                    <img
                      src={`data:image/jpeg;base64,${value}`}
                      alt={label}
                      width="150"
                    />
                  ) : Array.isArray(value) ? (
                    value.join(", ")
                  ) : (
                    String(value)
                  )}
                </td>
              </tr>
            );
          })}
          {"statuserrorMsg" in data && data.statuserrorMsg && (
            <tr>
              <th>Status Message</th>
              <td>{data.statuserrorMsg}</td>
            </tr>
          )}
          {"isEdited" in data && (
            <>
              <tr>
                <th>Is Edited</th>
                <td>{data.isEdited ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <th>Edited Reason</th>
                <td>{data.editedReason || "-"}</td>
              </tr>
            </>
          )}
          {"isLatest" in data && (
            <>
              <tr>
                <th>Is Latest</th>
                <td>{data.isLatest ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <th>Latest Error</th>
                <td>{data.islatesterrorMsg || "-"}</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    );
  };

  return (
    <div className="container containerBoreder">
      <h2 className="pageTitle">PI Document Upload</h2>
      <div className="row">
        <div className="col-4">
          <input type="file" onChange={onChange} />
        </div>
        <div className="col-4">
          {loading ? (
            <ReactBootStrap.Spinner animation="border" />
          ) : (
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>
      </div>
      <br />
      {data && renderData()}
    </div>
  );
}

export default PiData;
